"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadedType = exports.isTypeLoaded = void 0;
var loadedType = exports.loadedType = function loadedType(state) {
  return state.reducerManager.loadedType;
};
var isTypeLoaded = exports.isTypeLoaded = function isTypeLoaded(state, type) {
  return type ? state.reducerManager.loadedType === type : !!state.reducerManager.loadedType;
};
//# sourceMappingURL=selectors.js.map